import React, { useState, useEffect, useRef, useContext } from "react";

import { getVehicleLocations, getStopAndTerminalLocations } from "../Requests/MapRequests";
import MainContext from "../MainContext";
import BusMapFilter from "../Filters/BusMapFilter";

import "../Styles/BusMapStyles.css";

    // eslint-disable-next-line no-unused-vars
    const LOCATION_INTERVAL_TIME_MS = 20000;

    // determine which things to exclude form the map display
    const stylesArray = [   
        {
            "featureType": "poi.attraction",
            "stylers": [{"visibility": "off"}]
        },
        {
            "featureType": "poi.business",
            "stylers": [{"visibility": "off"}]
        },
        {
            "featureType": "poi.place_of_worship",
            "stylers": [{"visibility": "off"}]
        },
        {
            "featureType": "poi.school",
            "stylers": [{"visibility": "off"}]
        }
    ];

    let attempts = 0;


const BusMapPage = (props) => {


    const context = useContext(MainContext);


    const [map, setMap] = useState(null);
    const [hasMap, setHasMap] = useState(false);
    // const [radius, setRadius] = useState(null);
    const [busMarkerData, setBusMarkerData] = useState([]);
    const [stopMarkerData, setStopMarkerData] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [userPosition, setUserPosition] = useState(null);
    const [userMarker, setUserMarker] = useState(null);
    const [markerLookup, setMarkerLookup] = useState([]);
    const [boundsChanged, setBoundsChanged] = useState(true);
    const [usingGeolocation, setUsingGeolocation] = useState(false);
    const [currentPosition, setCurrentPosition] = useState(null);
    const [runDisplay, setRunDisplay] = useState(null);

    const [filterValue, setFilterValue] = useState([]);

    const [initialLoad, setInitialLoad] = useState(true);

    const [initialBusFound, setInitialBusFound] = useState(false);

    const mapRef = useRef(null);

    let interval = null;
    let boundsInterval = null;
    let isDragging = false;
    let clusterer = null;


    useEffect(() => {

        console.log("MAP HAS BEEN MOUNTED");
        console.log("MAP PROPS", props);

        // if geolocation is turned off, then don't fire off this event,
        // especially because it will keep cycling itself indefinitely
        if(usingGeolocation){
            attempts = 0;
            initializeMap();
        }
        else{
            console.log("NOT USING GEOLOCATION?");
        }

        if(navigator.permissions){
            navigator.permissions.query({name:'geolocation'})
            .then((permissionStatus) => {
                console.log('geolocation permission state is ', permissionStatus.state);
    
                processGeolocationState(permissionStatus);
    
                permissionStatus.onchange = () => {
                    console.log('geolocation permission state has changed to ', this.state);
                    processGeolocationState(permissionStatus);
                };
            })
            .catch(err => alert("permission query error: " + err.message));
        }

        console.log("FILTER ROUTE PARAMS", window.location.href);
        if(window.location.href.indexOf("?") > -1 && window.location.href.indexOf("route=") > -1){
            const query = window.location.href.substr(window.location.href.indexOf("route=") + 6);
            const param = query.split("&");
            console.log("ROUTE PARAM", param);
            setFilterValue(param);
        }
        // console.log("FILTER ROUTE PARAM", context.query);
        // if(context.query && context.query.valueForm){
        //     setFilterValue(context.query.valueForm);
        // }

        return () => {
            console.log("MAP UNMOUNTED ZZZ");
            clearInterval();
            cleanupMarkers();
            attempts = 0;
        }
    }, []);

    useEffect(() => {
        if(currentPosition && map){
            mapListenerSetup();
        }
        else{
            initializeMap();
        }
    }, [currentPosition, map])

    useEffect(() => {
        console.log("RUN DISPLAY CHANGED?", runDisplay);
        if(runDisplay){
            displayMarkers();
        }
    }, [runDisplay]);

    useEffect(() => {
        console.log("CHANGE THE FILTER");
        setInitialLoad(true);
        if(markers){
            runTheFilter();
        }
    }, [filterValue]);

    useEffect(() => {
        if(markers){
            runTheFilter();
        }
    }, [markers]);

    // useEffect(() => {
    //     runTheFilter();
    // }, [filterValue]);

    const runTheFilter = () => {
        console.log("GET DATA AFTER FILTER", filterValue);
        if(map){
            filterMarkers();
        }
        context.toggleFilter(null, false);
    }


    const applyFilter = (value) => {
        console.log("apply filter", value);
        setFilterValue(value);
    }


    const processGeolocationState = (permissionStatus) => {
        console.log("GEOLOCATION PERMISSION?", permissionStatus);
        switch(permissionStatus.state) {
            case "granted":
                console.log("GEOLOCATION PERMISSION GRANTED");
                setUsingGeolocation(true);

                console.log("GEO SET, DO WE START WATCHING?");

                if(!map){
                    initializeMap();
                }
                watchPosition();

                break;
            case "denied":
                setUsingGeolocation(false);
                break;
            case "prompt":
                watchPosition();
                break;
            default:
                // treat as denied
                setUsingGeolocation(false);
        }
    }

    const watchPosition = () => {
        console.log("WATCHNG THE GEO POSITION");

        geolocate();

        navigator.geolocation.watchPosition((position) => {
            console.log("WATCHING FOR NEW GEO POSITION", position);
            setUsingGeolocation(true);

            let proceed = !currentPosition;
            proceed |= minPositionDifference(position, currentPosition);

            console.log("PROCEED?", proceed, position);

            if(proceed){
                console.log("PROCEEDING WITH SET POSITION", position.coords);
                setCurrentPosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            }
        },
        function(error) {
            if (error.code == error.PERMISSION_DENIED){
                setUsingGeolocation(false);
            }
        });
    }

    const minPositionDifference = (positionNew, positionOld) => {

        const latNew = positionNew.coords.latitude;
        const lonNew = positionNew.coords.longitude;
    
        if(positionOld){
            const latOld = positionOld.lat;
            const lonOld = positionOld.lng;
        
            const latDiff = Math.abs(latNew - latOld);
            const lonDiff = Math.abs(lonNew - lonOld);
        
            return (latDiff > 0.00005 || lonDiff > 0.0006);
        }
        else{
            return true;
        }
    }

    const geolocate = () => {
        console.log("GEOLOCATING");
        navigator.geolocation.getCurrentPosition(position => {
            console.log("WE GOT A GEO POSITION", position);

            if(position){
                setUsingGeolocation(true);
                setCurrentPosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            }
            else{
                setTimeout(geolocate, 50);
            }
        }, (err) => {
            console.log("GEO LOCATING GET CURRENT ERROR", err);
            if(err.code === 3){
                geolocate();
            }
        }, 
        {timeout: 1000, enableHighAccuracy: false, maximumAge:Infinity}
        );

        // setTimeout(()=> {
        //     if(!this.currentPosition){
        //         this.geolocate();
        //     }
        // }, 50);
    }

    const googleMapCheck = () => {
        console.log("GOOGLE MAP CHECK", window.google, window.google.map);
        if(window.google && window.google.maps) {
            console.log("CHANGE MAP POSITION, WITH MAP", this.currentPosition);
            onBoundsChanged();
        }
        else{
            console.log("GOOGLE MAP CHECK REPEAT");
            setTimeout(googleMapCheck, 50);
        }
    }
    
    const getData = () => {
        console.log("GET VEHICLE DATA START");

        if(!filterValue || filterValue.length === 0){
            setInitialLoad(false);
            return;
        }

        createPositionMarker();

        const bounds = map.getBounds();
        const mapLat = bounds.getCenter().lat();
        const mapLng = bounds.getCenter().lng();

        // get the center and upper right corner of the map

        // const params = {lat, lng, radius};
        const params = {lat: mapLat, lng: mapLng, radius: getCurrentMapRadiusInKM(map)};
        let iconValue = "";

        const url = window.location.href;
        const mainURL = ""; // url.substring(0, url.indexOf("/map"));

        const iconBus = mainURL + "/map_icons/bus_icon_blue2.png";

        console.log("ICON LOCATION", iconBus);

        let xOrigin = 0;

        console.log("MAP PROPS", props);

        params.mode = "BUS";
        iconValue = iconBus;
        xOrigin = 9;

        // this.cleanupMarkers();

        console.log("GET LOCATION PARAMS", params);

        let proceed = true;
        // let proceed = false;

        // don't get the stops unless we're properly zoomed in
        if(map.getZoom() < 14){
            console.log("DON'T GET STOP DATA??");
            // return;
            // continue for now
            // proceed = false;
        }

        const requests = [];
        const vehiclePromise = getVehicleLocations(params);
        
        requests.push(vehiclePromise);
        
        if(proceed){
            // const stopPromise = getStopAndTerminalLocations(params);
            // requests.push(stopPromise);
        }
        else {
            console.log("GOING TO GET STOP AND TERMINAL LOCATIONS", params);
            getStopAndTerminalLocations(params)
            .then(({data}) => {
                let dataToUse = data;

                console.log("MAP DISPLAY STOP AND TERMINAL LOCATIONS", data);

                if(this.pageType === "bus"){
                    dataToUse = data.length > 3 ? data.slice(0,3) : data;
                }

                // this.$store.commit("setStopLocations", dataToUse);
            })
            .catch(err => {
                if((err.response && err.response.status === 408) || err.code === 'ECONNABORTED'){
                    console.log("STOPS TIMEOUT", new Date(), err);
                }
                // this.$store.commit("setStopLocations", []);
            });
        }

        console.log("ALL REQUESTS", requests);

        Promise.allSettled(requests)
        .then(results => {
            console.log("LOCATION QUERY RESULTS", results);
            if(results[0].status === "fulfilled"){
                const { data } = results[0].value;
                // skip this for now and see what happens

                console.log("THE INNER DATA", data);

                // let dtu = [];
                // if(data.length > 0){
                //     data.forEach(d => {
                //         if(d.VehicleID === "21347"
                //             || d.VehicleID === "21319"
                //             || d.VehicleID === "5379"
                //             || d.VehicleID === "22087"
                //             || d.VehicleID === "6263"
                //         ){
                //             dtu.push(d);
                //         }
                //     })
                // }

                // console.log("DATA TO USE", dtu);

                if(data.length > 0 && !initialBusFound){
                    setInitialBusFound(true);
                    placeMapCenterWithBus(data[0])
                }

                fulfillVehiclePromise(data, iconValue, xOrigin);
            }
            else if(results[0].status === "rejected"){
                // this.$store.commit("setVehicleLocations", []);
            }

            if(results.length > 1 && proceed && results[1].status === "fulfilled"){
                const { data } = results[1].value;
                fulfillStopsPromise(data, xOrigin);
            }

            console.log("FINISHED ALL MARKERS?", busMarkerData);

            setTimeout(() => {
                console.log("SET THE RUN DISPLAY VALUE", busMarkerData);
                setRunDisplay(new Date()); 
            }, 100);
        })
        .catch(err => {
            console.log("IS THIS A MAP TIMEOUT?", err);
            if((err.response && err.response.status === 408) || err.code === 'ECONNABORTED'){
                console.log("TIMEOUT");
            }
            
        });
    }

    const placeMapCenterWithBus = (vehicle) => {
        const position = {
            lat: parseFloat(vehicle.VehicleLat),
            lng: parseFloat(vehicle.VehicleLong)
        }
        map.setCenter(position);
    }

    const fulfillVehiclePromise = (data, iconValue, xOrigin) => {
        console.log("VEHICLE DATA FULFILL PROMISE", data, iconValue);
        console.log("MOVING VEHICLE DATA", data);

        // don't do anything if the data comes back empty
        if(data.length === 0){
            return;
        }

        const vehicle_markers = [];

        // this.$store.commit("setVehicleLocations", data);

        // const batch = Math.floor(Math.random() * 100);

        const routeCount = {};

        data.forEach(vehicle => {

            if(routeCount[vehicle.VehicleRoute]){
                routeCount[vehicle.VehicleRoute]++;
            }
            else{
                routeCount[vehicle.VehicleRoute] = 1;
            }

            const iconSize = 25;

            const marker = {
                position: {
                    lat: parseFloat(vehicle.VehicleLat),
                    lng: parseFloat(vehicle.VehicleLong)
                },
                icon: {
                    url: iconValue,
                    scaledSize: new window.google.maps.Size(iconSize, iconSize),
                    labelOrigin: {x: xOrigin, y: -10}
                },
                label: {
                    text: vehicle.VehicleRoute + " - #" + vehicle.VehicleID, // + " " + batch,
                    // text: bus.VehicleID,
                    fontWeight: "bold",
                    fontSize: "16px",
                    border: "1px solid black",
                    className: "label",
                    color: "#cc5522" // "#426bd4"
                },
                id: vehicle.VehicleID,
                internalNumber: vehicle.VehicleInternalTripNumber,
                route: vehicle.VehicleRoute,
                destination: vehicle.VehicleDestination,
                time: vehicle.VehicleScheduledDeparture,
                isVehicle: true,
                category: "trip"
            };
            vehicle_markers.push(marker);

            // console.log("INDIVIDUAL MARKER", vehicle, vehicle.VehicleID, marker.position.lat, marker.position.lng, marker, iconValue);
        });

        console.log("ROUTE COUNT", routeCount);

        setBusMarkerData(vehicle_markers);
    }

    const fulfillStopsPromise = (data, xOrigin) => {
        console.log("STOP LOCATION DATA MEMBER HERE", data);

        const stop_markers = [];

        let dataToUse = data;

        if(this.pageType === "bus"){
            dataToUse = data.length > 3 ? data.slice(0,3) : data;
        }

        // this.$store.commit("setStopLocations", dataToUse);

        let stopIcon = null;

        const currentFullURL = window.location.href;
        const dotCom = currentFullURL.indexOf(".com");
        let path = currentFullURL.substring(0, dotCom);
        path += ".com";

        if(this.pageType === "bus"){
            // stopIcon = require("../assets/bus_stop_icon_green.png");
            stopIcon = path + "/map_icons/bus_stop_icon_green.png";
        }
        else if(this.pageType === "rail") {
            // stopIcon = require("../assets/njt_circle_logo_smallicon.png");
            stopIcon = path + "/map_icons/njt_circle_logo_smallicon.png";
        }

        console.log("STOPS DATA MEMBER TO USE", dataToUse, stopIcon);

        dataToUse.forEach(stop => {
            const marker = {
                position: {
                    lat: parseFloat(stop.latitude),
                    lng: parseFloat(stop.longitude)
                },
                icon: {
                    url: stopIcon,
                    labelOrigin: {x: xOrigin, y: -8}
                },
                label: {
                    text: stop.busstopdescription,
                    fontWeight: "bold",
                    fontSize: "14px",
                    labelClass: "label"
                },
                description: stop.busstopdescription,
                id: stop.busstopnumber,
                isVehicle: false,
                category: "stop"
            };
            stop_markers.push(marker);

            console.log("STOPS DATA MEMBER", stop_markers);
        });

        setStopMarkerData(stop_markers);
    }
    
    const cleanupMarkers = (doNotEmpty = false) => {
        console.log("CLEAR ALL MARKERS", markers);

        if(clusterer){
            clusterer.clearMarkers();
        }

        markers.forEach(marker => {
            clearMarker(marker);
        });

        if(!doNotEmpty){
            setMarkers([]);
        }
    }

    const clearMarker = (marker) => {
        console.log("clear MARKER", marker);
        marker.setMap(null);
        window.google.maps.event.clearInstanceListeners(marker);
    }
    
    const displayMarkers = () => {
        // always clear before drawing
        // but don't clear the component's data
        // this.cleanupMarkers(true);

        if(clusterer){
            clusterer.clearMarkers();
        }

        console.log("DISPLAY TEST", map, map.markers);

        displayUserMarker();

        const newLookup = {};

        let allMarkerData =  [...busMarkerData, ...stopMarkerData];
        
        console.log("ALL MARKERS", busMarkerData, allMarkerData);

        console.log("STOP MARKERS", stopMarkerData);
        // const allMarkerData =  [this.busMarkerData[1], this.busMarkerData[2]];
        console.log("DISPLAY MARKERS", allMarkerData.length, allMarkerData);

        const mapMarkers = allMarkerData.map(marker => {
            // create marker, add to map, set event listener

            //    VehicleID: "6429"
            //    VehicleLat: "40.73215103149414"
            //    VehicleLong: "-74.18132019042969"
            
            console.log("MOVING MARKER LOOP", marker, marker.id);

            const match = markerLookup[marker.id];
            if(match){
                console.log("UPDATE MOVING MARKER MATCH", marker.id, marker.position.lat, marker.position.lng);
                console.log("UPDATE PREVIOUS", marker.id, match);
                updateMarkerLocation(marker, match);
                // remove these here so they don't get cleared later 
                delete markerLookup[marker.id];
                newLookup[marker.id] = match;
                return match;
            }
            else{
                console.log("NEW MOVING MARKER", marker.id, marker.position.lat, marker.position.lng);
                const mapMarker = new window.google.maps.Marker(marker);
                mapMarker.setMap(map);
                // window.google.maps.event.addListener(mapMarker, 'click', () => {
                //     // nothing here yet
                //     console.log("MARKER CLICKED", mapMarker);
                // });

                console.log("CREATE LINK FROM MARKER", marker);

                newLookup[marker.id] = mapMarker;
                return mapMarker;
            }
        });

        // console.log("FULL LOOKUP", markerLookup);

        Object.keys(markerLookup).forEach(key => {
            const marker = markerLookup[key];
            clearMarker(marker);
        });

        setMarkerLookup(newLookup);
        // console.log("MOVING LOOKUP", newLookup);

        // set the state, so we'll be able to refer to them later for removal
        console.log("CURRENT MARKERS", mapMarkers);
        if(filterValue.length){
            filterMarkers();
        }
        setMarkers(mapMarkers);

        // Add a marker clusterer to manage the markers.
        // clusterer = new window.MarkerClusterer(map, markers, {
        //     imagePath:
        //     "/map_cluster_icons/m",
        // });

        // skip this filter for now
        // filterMarkers();
    }
    
    const createPositionMarker = () => {
        const currLat = currentPosition.lat;
        const currLng = currentPosition.lng;

        setUserPosition({
            position: {
                lat: currLat,
                lng: currLng
            }
        });
    }
    
    const displayUserMarker = () => {
        console.log("USER MARKER HAVE BOUNDS CHANGED", boundsChanged);
        if(boundsChanged){
            if(userMarker){
                clearMarker(userMarker);
            }

            console.log("INITIAL MAP MARKER", userPosition);

            const mapMarker = new window.google.maps.Marker(userPosition);
            mapMarker.setMap(map);

            setUserMarker(mapMarker);
            setBoundsChanged(false);
        }
    }

    const updateMarkerLocation = (marker, mapMarker) => {

        // console.log("MOVING UPDATE", marker, mapMarker);

        const origPos = mapMarker.getPosition();
        const origLat = origPos.lat();
        const origLng = origPos.lng();

        let newLat = marker.position.lat;
        let newLng = marker.position.lng;

        const latUnit = (newLat - origLat)/10;
        const lngUnit = (newLng - origLng)/10;

        if(latUnit == 0 && lngUnit == 0){
            // nowhere to go
            console.log("NO DIFFERENCE", marker.id);

            var latlng = new window.google.maps.LatLng(newLat, newLng);
            mapMarker.setPosition(latlng);

            return;
        }

        console.log("MARKER POSITION CHECK", marker.id, origLat, origLng);

        // I don't think this belongs here
        var latlng = new window.google.maps.LatLng(newLat, newLng);
        // mapMarker.setPosition(latlng);

        // console.log("MOVING MARKER UPDATE LATLNG", marker.id, marker, latlng, newLat, newLng, latUnit, lngUnit);

        const a = Math.random();
        let step = 0;
        const step_interval = setInterval(() => {
            var latlng = new window.google.maps.LatLng(origLat + step*latUnit, origLng + step*lngUnit);
            // console.log("MOVING", newLat, newLng, a);
            mapMarker.setPosition(latlng);

            step++;
            if(step >= 10) {
                window.clearInterval(step_interval);
            }
        }, 50);
    }
    
    const getCurrentMapRadiusInKM = (map) => {

        const bounds = map.getBounds();

        console.log("MAP BOUNDS", bounds);

        // get the center and upper right corner of the map
        const center_lat = bounds.getCenter().lat();
        const center_lng = bounds.getCenter().lng();
        const ne_lat = bounds.getNorthEast().lat();
        const ne_lng = bounds.getNorthEast().lng();

        // r = radius of the earth in statute miles
        const earth = 3963.0;  
        const earthKM = earth * 1.609;

        const KM_TO_FEET = 3280;

        // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
        const lat1 = center_lat / 57.2958; 
        const lon1 = center_lng / 57.2958;
        const lat2 = ne_lat / 57.2958;
        const lon2 = ne_lng / 57.2958;

        // distance = circle radius from center to Northeast corner of bounds
        const distance = earthKM * Math.acos(Math.sin(lat1) * Math.sin(lat2) + 
        Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));

        return distance * KM_TO_FEET;
    }

    const onBoundsChanged = () => {

        // called whenever the map is zoomed or dragged
        // 
        // for dragging, only run *after* the dragging has been completed

        console.log("BOUNDS CHANGED", !isDragging, !boundsInterval);

        if(!isDragging && !boundsInterval){
            // edge case:
            // make sure this doesn't get called again
            // after dragging stops
            boundsInterval = setInterval(() => {
                window.clearInterval(boundsInterval);
                boundsInterval = null;
            }, 300);

            console.log("BOUNDS CHANGED, NOT DRAGGING ZZZ");
            clearInterval();

            // const r = Math.ceil(getCurrentMapRadiusInKM(map));

            // console.log("GET SOME DATA");

            // change the status in the Vuex store, so that
            // we get the loading message again
            // only need to do this for the vehicles
            // because the stops won't change in this way
            // this.$store.commit("setVehiclesLoaded", false);

            // if we don't have data for the stops, then do the same for the stops
            // if(!this.$store.stopLocations || !this.$store.stopLocations.length){
            //     this.$store.commit("setStopsLoaded", false);
            // }

            // get the data and then set an interval to keep updating it
            // this.getData(radius);
            getData();
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            console.log("SET THE DATA INTERVAL", LOCATION_INTERVAL_TIME_MS);
            interval = window.setInterval(() => getData(), LOCATION_INTERVAL_TIME_MS);

            console.log("CURRENT MAP ZOOM LEVEL", map.getZoom());

            setBoundsChanged(true);
        }
        else{
            console.log("DRAGGING");
        }
    }
    
    const dragStart = () => {
        console.log("DRAG START ZZZ");
        clearInterval();
        // this.cleanupMarkers();
        isDragging = true;
        setMarkers([]);
    }
    
    const dragEnd = () => {
        console.log("DRAG END");
        isDragging = false;
        onBoundsChanged();
    }

    const clearInterval = () => {
        console.log("ARE WE CLEARING THE INTERVAL?", interval);
        if(interval) {
            console.log("CLEAR INTERVAL");
            window.clearInterval(interval);
            interval = null;
        }
    }

    const markerClick = (marker) => {
        console.log("MARKER CLICKED!", marker);
    }

    const filterMarkers = () => {
        console.log("FILTERING THE MARKERS", markers, markers.length);
        const markersToShow = [];

        let count = 0;

        markers.forEach(m => {
            // basic filtering of markers done here
            const showTrips = true;
            const showStops = true;
            if(!filterValue || filterValue.length < 1 || (filterValue.length > 0 && showTrips && filterValue.includes(m.route))){
                console.log("FILTER CHECK", m.route, filterValue, filterValue > -1, showTrips, filterValue.includes(m.route));
                m.setVisible(true);
                markersToShow.push(m);
                count++;
            }
            else{
                m.setVisible(false);
            }
        });

        if(initialLoad) {
            setInitialLoad(false);
            console.log("INITIAL LOAD COMPLETE");
            if(count === 0){
                alert("No buses found for current filter");
            }
        }


        // setMarkers(markersToShow);

        // no clusterer here
        return;

        if(clusterer){
            clusterer.clearMarkers();
            clusterer.addMarkers(markersToShow);
        }
        else{
            // do I need to add these manually?
            console.log("NO CLUSTERER", markersToShow);
        }
    }

    const initializeMap = () => {
        console.log("INITIALIZE MAP ATTEMPT with props", window.google, currentPosition);

        // if the map objects have been loaded from google already then
        // proceed with initialization, otherwise set a timer to try again

        // initialization:
        // set parameters, set styles, set event listeners, 
        // set initial scale, get the data

        // this.currentPosition.lat = 40.7357
        // this.currentPosition.lng = -74.1974;

        if(map || !currentPosition){
            return;
        }

        if(window.google && window.google.maps){
            console.log("WE HAVE THE GOOGLE MAPS OBJECT NOW");

            const options = {
                center: currentPosition,
                zoom: 15,
                panControl: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: true,
                rotateControl: false
            }

            console.log("INITIAL POSITION", currentPosition, mapRef);

            if(mapRef && mapRef.current){
                console.log("WE HAVE A MAP REF", mapRef);
                setMap(new window.google.maps.Map(mapRef.current, options));
                setHasMap(true);
            }
            else{
                console.log("NO MAP REF", mapRef);
            }
        }
        else{
            // if we don't get it after 30 seconds, just stop trying
            console.log("NO GOOGLE MAP YET", window.google, window.google.maps, currentPosition);

            if(attempts < 3000){
                setTimeout(initializeMap, 100);
                attempts++;
            }
        }
    }


    const mapListenerSetup = () => {
        console.log("MAP OBJECT IS HERE", map, currentPosition);

        map.set("styles", stylesArray);

        map.addListener("bounds_changed", onBoundsChanged);
        map.addListener("center_changed", onBoundsChanged);
        map.addListener("dragstart", dragStart);
        map.addListener("dragend", dragEnd);

        const bounds = map.getBounds();

        if(bounds){
            getData();
        }
        else{
            window.google.maps.event.addListenerOnce(map, 'idle', function(){
                console.log("MAP IDLE CALLBACK");
                getData();
            });
        }
    }


    //
    //
    //
    //
    //
    //
    // RENDER
    //
    //
    //
    //
    //
    //

    return (
        //    display: grid; grid-template-rows: 3fr 1fr
        <div style={{position: "relative"}}>
            {
                // the filter
                context.hasFilter
                && context.filterOpen
                    ? <BusMapFilter applyFilter={applyFilter} filterValue={filterValue} />
                    : null
            }
            <div id="map-parent" style={{height: "90vh", width: "100vw", position: "relative"}}>
                <div id="map" ref={mapRef} className="map"></div>
                {
                    !hasMap
                    ? <div id="loading-message" className="loading-message">
                        Map Loading...
                    </div>
                    : null
                }
            </div>
            {
                initialLoad
                ? <div className="processing">
                    <span className="processing-text">Processing</span><span className="processing1">.</span><span className="processing2">.</span><span className="processing3">.</span>
                </div>
                : null
            }
        </div>
    )
};

export default BusMapPage;